// A reservation timeline below Inbox; Google remains dormant.
import { createRoute } from "@tanstack/react-router";
import { m } from "@trameria/i18n";
import { defineScreenPart } from "../app/screen-part";
import { iconOf } from "../ui/icon";
import { TimeBlockerMenuBar } from "./menu-bar";
import { calendarChanged, timeBlockerChanged } from "./queries";
import { TimeBlockerReviewScreen } from "./review";
import { useRunningBadge, useRunningBadgeData } from "./running";
import { type BlockLinkSearch, TimeBlockerScreen } from "./screen";

export const TIMEBLOCKER_PATH = "/me/timeblocker";

export const timeBlockerScreen = defineScreenPart({
  id: "timeblocker",
  nav: {
    order: 15,
    label: () => m.timeblocker_title(),
    icon: iconOf("timeblocker"),
    to: TIMEBLOCKER_PATH,
    useBadge: useRunningBadge,
    useBadgeData: useRunningBadgeData,
  },
  routes: (main) => [
    createRoute({
      getParentRoute: () => main,
      path: "timeblocker",
      // A notice's block (its detail opens) and its "Start" button.
      validateSearch: (search: Record<string, unknown>): BlockLinkSearch => ({
        ...(typeof search.block === "string" ? { block: search.block } : {}),
        ...(search.action === "start" ? { action: "start" as const } : {}),
      }),
      component: TimeBlockerScreen,
    }),
    createRoute({
      getParentRoute: () => main,
      path: "timeblocker/review",
      component: TimeBlockerReviewScreen,
    }),
  ],
  realtime: {
    "timeblocker.changed": (_payload, { qc }) => timeBlockerChanged(qc),
    // A title, a plan or a status of an Action changed (or a Case closed).
    "case.changed": (_payload, { qc }) => timeBlockerChanged(qc),
    "case.deleted": (_payload, { qc }) => timeBlockerChanged(qc),
    "calendar.changed": (_payload, { qc }) => calendarChanged(qc),
  },
  settings: [],
  // The desktop app's menu bar shows the running (else next) Block.
  Background: TimeBlockerMenuBar,
  shortcuts: [
    {
      id: "timeblocker.go",
      key: "g n",
      group: "navigate",
      label: () => m.timeblocker_go(),
      run: ({ navigate }) => navigate(TIMEBLOCKER_PATH),
    },
  ],
});
